import { render, staticRenderFns } from "./CouponInvoiceDetail.vue?vue&type=template&id=221632e5&scoped=true"
import script from "./CouponInvoiceDetail.vue?vue&type=script&lang=js"
export * from "./CouponInvoiceDetail.vue?vue&type=script&lang=js"
import style0 from "./CouponInvoiceDetail.vue?vue&type=style&index=0&id=221632e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221632e5",
  null
  
)

export default component.exports